const groupPrefix = createApiRoute(ApiModule.PRODUCTION_PLANNING, ApiModule.EMPLOYEE, ApiDataModel.PRODUCTION_MACHINES)

export const apiProductionMachines = {
	fetchMachineChangeovers: async (
		machineID: number,
	): Promise<IApiResponseModel<IProductionMachineChangeoverModel[]>> => {
		const { data } = await apiCommon<IProductionMachineChangeover[]>(`${groupPrefix}/${machineID}/changeovers`, {
			method: 'GET',
		})

		return { data: data.map(ProductionMachineChangeover) }
	},
}
